import React from "react";
import RichEditor from "@/components/RichEditor";

export default function StepPolicies({ q, setQ }) {
  const upd = (k, v) => setQ((p) => ({ ...p, policies: { ...p.policies, [k]: v } }));
  return (
    <div className="space-y-5">
      <div><div className="overline text-[9px] mb-2">Payment Policy</div><RichEditor testid="qp-payment" value={q.policies.payment_policy} onChange={(v)=>upd("payment_policy", v)} /></div>
      <div><div className="overline text-[9px] mb-2">Cancellation Policy</div><RichEditor testid="qp-cancel" value={q.policies.cancellation_policy} onChange={(v)=>upd("cancellation_policy", v)} /></div>
      <div><div className="overline text-[9px] mb-2">Terms & Conditions</div><RichEditor testid="qp-terms" value={q.policies.terms_conditions} onChange={(v)=>upd("terms_conditions", v)} /></div>
    </div>
  );
}
